<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Webinar</v-flex>
                    <v-flex v-else>Update Webinar</v-flex>
                    <v-btn icon @click="ClearForm">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-text-field label="Webinar Title" v-model="Webinar_Title"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-flex style="font-size: 16px;font-weight: 500;padding: 10px;">Webinar Description : </v-flex>
                        <vue-editor v-model="Webinar_Description"></vue-editor>
                    </v-flex>
                    <v-flex style="padding-top: 14px;">
                        <v-menu ref="Webinar_Date_Menu" v-model="Webinar_Date_Menu" :close-on-content-click="false" transition="scale-transition" offset-y
                                full-width max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="Webinar_Date" label="Webinar Date" persistent-hint
                                prepend-icon="event" v-on="on" ></v-text-field>
                            </template>
                            <v-date-picker v-model="Webinar_Date" no-title @input="Webinar_Date_Menu = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-menu ref="menu" v-model="Webinar_Time_Menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="Time"
                                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="Time" label="Webinar Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                        </template>
                            <v-time-picker v-if="Webinar_Time_Menu" v-model="Time" full-width @click:minute="$refs.menu.save(Time)"></v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-radio-group row v-model="Webinar_Type">
                            <v-radio label="Webinar Link" value="Webinar_Link"></v-radio>
                            <v-radio label="Webinar Form" value="Webinar_Form"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex v-if="Webinar_Type == 'Webinar_Link'">
                        <v-text-field label="Webinar Link" v-model="Webinar_Link"></v-text-field>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="primary" v-if="!Update_Details" @click="AddWebinar">Add Webinar</v-btn>
                        <v-btn color="primary" v-else @click="UpdateWebinar">Update Webinar</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
    props: ['dialog'],
    components:{
        VueEditor
    },
    data(){
        return {
            Webinar_Title       : "",
            Webinar_Description : "",
            Webinar_Date        : new Date().toISOString().substr(0, 10),
            Webinar_Date_Menu   : false,
            Webinar_Time_Menu   : false,
            Webinar_Type        : '',
            Time                : null,
            Webinar_Link        : '',
            Update_Details      : false,
            Webinar_Id          : ""
        }
    },
    methods:{
        OpenUpdate(item){
            
            this.Update_Details      = true
            this.Webinar_Id          = item['_id']
            this.Webinar_Title       = item['Webinar_Title'],
            this.Webinar_Description = item['Webinar_Description'],
            this.Webinar_Date        = new Date(item['Webinar_Date_Time']).toISOString().substr(0, 10),
            this.Time                = new Date(item['Webinar_Date_Time']).toLocaleTimeString()
            this.Webinar_Type        = item['Webinar_Type']
            this.Webinar_Type == 'Webinar_Link' ? this.Webinar_Link = item['Webinar_Link'] : {}
        },
        AddWebinar(){
            let data = {
                'Webinar_Title' : this.Webinar_Title,
                'Webinar_Description' : this.Webinar_Description,
                'Webinar_Date_Time' : new Date(`${this.Webinar_Date},${this.Time}`),
                'Webinar_Type'      : this.Webinar_Type
            }
            this.Webinar_Type == 'Webinar_Link' ? data['Webinar_Link'] = this.Webinar_Link : {}
            if( this.Webinar_Title && this.Webinar_Description && this.Webinar_Date && this.Time && this.Webinar_Type ){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/webinar/addwebinar`,data)
                        .then(response =>{

                            this.$store.commit("SetIndividualWebinar",response['data']['response'])
                            this.ClearForm()
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Webinar","Color":"green","Close": false });
                        })
                        .catch(err =>{
    
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Webinar","Color":"red","Close": false });
                        })
            }else{
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill all the details","Color":"red","Close": false });
            }

        },
        UpdateWebinar(){

            let data = {}
            data['Webinar_Id'] = this.Webinar_Id
            data['Update'] = {
                'Webinar_Title'       : this.Webinar_Title,
                'Webinar_Description' : this.Webinar_Description,
                'Webinar_Date_Time' : new Date(`${this.Webinar_Date},${this.Time}`),
                'Webinar_Type'      : this.Webinar_Type
            }
            this.Webinar_Type == 'Webinar_Link' ? data['Update']['Webinar_Link'] = this.Webinar_Link : {}

            if(this.Webinar_Id && this.Webinar_Title && this.Webinar_Description && this.Webinar_Date && this.Time && this.Webinar_Type ){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/webinar/updatewebinar`,data)
                        .then(response =>{
                            
                            this.$store.commit("UpdateIndividualWebinar",response['data']['response'])
                            this.ClearForm()
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Webinar","Color":"green","Close": false });
                        })
                        .catch(err =>{
    
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Webinar","Color":"red","Close": false });
                        })
            }else{
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill all the details","Color":"red","Close": false });
            }
        },
        ClearForm(){

            this.Webinar_Id      = ""
            this.Webinar_Title   = ""
            this.Webinar_Description = ""
            this.Webinar_Date = new Date().toISOString().substr(0, 10)
            this.Time         = null
            this.Webinar_Type = ""
            this.Update_Details = false
            this.$emit('close')
        }
    }
}
</script>
<style scoped>

</style>